import { Modal } from "../../../components/others/Modal/index";
import RequestAbsenceAlertContent from "./requestAbsencesAlert";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
};

const RequestAbsencesAlert = ({ toggleModal, urlTittle }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";

  return (
    <>
      <Modal show={toggleModal} titleStyle={styles} urlTittle={urlTittle}>
        <RequestAbsenceAlertContent />
      </Modal>
    </>
  );
};

export default RequestAbsencesAlert;
